module.exports = __webpack_public_path__ + "img/sld_ch_7_t1_green.2586f5ee.svg";